import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useEffect, useRef } from "react";
import CurrentLocation from "./googlemaps-helpers/CurrentLocation";
import GoogleMapsSearch from "./googlemaps-helpers/GoogleMapsSearch";
import { options } from "./googlemaps-helpers/mapSettings";
import { useLang } from "@/providers/langProvider";
import { useGetUserLocation } from "@/api/AppApi/services/cart";

interface Props {
  width: number | string;
  height: number | string;
  position: google.maps.LatLngLiteral;
  setPosition?: (position: google.maps.LatLngLiteral) => void;
  viewOnly?: boolean;
  search?: boolean;
}

const places = ["places"];
const SiteGoogleMap: React.FC<Props> = ({
  width,
  height,
  position,
  setPosition,
  viewOnly = false,
  search = false,
}) => {
  const lang = useLang();

  const { data, isFetching } = useGetUserLocation({ enabled: true });
  const currentLocation: google.maps.LatLngLiteral = {
    lat: data?.latitude ?? 0,
    lng: data?.longitude ?? 0,
  };
  const mapRef = useRef<google.maps.Map | null>(null);
  const onLoad = (map: google.maps.Map): void => {
    mapRef.current = map;
  };
  const setNewPosition = (position: google.maps.LatLngLiteral) => {
    setPosition?.(position);
  };
  useEffect(() => {
    !viewOnly && setNewPosition(position?.lat ? position : currentLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position?.lat, data]);
  const moveTo = (position: google.maps.LatLngLiteral) => {
    if (mapRef.current) {
      mapRef.current.panTo({ ...position });
      mapRef.current.setZoom(12);
      setNewPosition(position);
    }
  };
  const onUnmount = () => {
    mapRef.current = null;
  };
  const onMapClick = (e: google.maps.MapMouseEvent) => {
    !viewOnly &&
      setNewPosition({ lat: e.latLng?.lat() ?? 0, lng: e.latLng?.lng() ?? 0 });
  };
  const onSelect = (position: google.maps.LatLngLiteral) => {
    if (mapRef.current) {
      mapRef.current.panTo({ ...position });
      mapRef.current.setZoom(4);
      setNewPosition(position);
    }
  };
  const putMarker = !!position?.lat;
  const TsGoogleMap: any = GoogleMap;
  const TsMarker: any = Marker;

  return isFetching ? null : (
    <div className="map">
      {/* @ts-ignore */}
      <LoadScript
        googleMapsApiKey="AIzaSyBnuJc1nQWa4c2KNkkVe-pnrd38Vq6aiKI"
        language={lang}
        libraries={places as any}
      >
        {!viewOnly && <CurrentLocation moveTo={moveTo} />}
        {search && <GoogleMapsSearch onSelect={onSelect} />}
        <TsGoogleMap
          mapContainerStyle={{ width: width, height: height }}
          options={options}
          center={
            position && position.lat !== 0 ? position : { lat: 0, lang: 0 }
          }
          zoom={putMarker ? 14 : 1}
          onLoad={onLoad}
          onUnmount={onUnmount}
          onClick={onMapClick}
        >
          {putMarker && (
            <TsMarker
              draggable={!viewOnly}
              onDragEnd={onMapClick}
              position={position ?? { lat: 0, lang: 0 }}
              icon={{
                url: "/img/test/marker.svg",
                scaledSize: {
                  width: 40,
                  height: 40,
                  equals: () => true,
                },
              }}
            />
          )}
        </TsGoogleMap>
      </LoadScript>
    </div>
  );
};

export default SiteGoogleMap;
